import React, { createContext, useContext, useEffect, useState } from 'react';
import { usePushNotifications } from '../hooks/usePushNotifications';

const PushNotificationContext = createContext();

export const usePushNotificationContext = () => {
  const context = useContext(PushNotificationContext);
  if (!context) {
    throw new Error('usePushNotificationContext muss innerhalb eines PushNotificationProvider verwendet werden');
  }
  return context;
};

export const PushNotificationProvider = ({ children }) => {
  const {
    pushToken,
    lastNotification,
    notifications,
    isInitialized,
    sendTokenToServer,
    markNotificationAsRead,
    clearAllNotifications,
    loadDeliveredNotifications
  } = usePushNotifications();

  const [unreadCount, setUnreadCount] = useState(0);

  // Ungelesene Benachrichtigungen zählen
  useEffect(() => {
    const unread = notifications.filter(notification => !notification.read).length;
    setUnreadCount(unread);
  }, [notifications]);

  // Neue Benachrichtigung anzeigen (falls gewünscht)
  const showNotificationAlert = (notification) => {
    // Hier können Sie eine Toast-Benachrichtigung oder Modal anzeigen
    console.log('Neue Benachrichtigung:', notification);
  };

  // Bei neuer Benachrichtigung Alert anzeigen
  useEffect(() => {
    if (lastNotification) {
      showNotificationAlert(lastNotification);
    }
  }, [lastNotification]);

  const value = {
    pushToken,
    lastNotification,
    notifications,
    unreadCount,
    isInitialized,
    sendTokenToServer,
    markNotificationAsRead,
    clearAllNotifications,
    loadDeliveredNotifications,
    showNotificationAlert
  };

  return (
    <PushNotificationContext.Provider value={value}>
      {children}
    </PushNotificationContext.Provider>
  );
};
